import type { GridFilterOperator } from "@mui/x-data-grid-premium";

const classNamespace = "ExonnDataGrid";

export const dataGridClasses = {
  cellWithoutPadding: `${classNamespace}-cell--no-padding`,
  cellOverflowVisible: `${classNamespace}-cell--overflow-visible`,
  groupingCell: `${classNamespace}-cell--grouping`,
  expandedRow: `${classNamespace}-row--expanded`,
  lastRowInGroup: `${classNamespace}-row--lastInGroup`,
  appliedFilterCell: `${classNamespace}-cell--appliedFilterCell`,
};

export const noopFilterOperators: GridFilterOperator[] = [
  {
    value: "",
    headerLabel: "",
    getApplyFilterFn: () => null,
    label: "",
  },
];
